module.exports = __webpack_public_path__ + "img/Citroen.a6c3534b.png";